<template>
    <div
        class="form-group"
        :class="[
            { 
                active: true,
                'label-inside': labelInside,
            },
            parentClass
        ]"
    >
        <label
            v-if="label"
            :for="uniqueId"
            class="form-group-label"
        >
            {{ label }}
        </label>
        <select
            v-model="inputValue"
            v-bind="$attrs"
            @change="handleInput"
            class="custom-select form-control"
            :id="uniqueId"
        >
            <option
                v-for="(option, index) in inputOptions"
                :value="option.value"
                :key="index"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        name: 'UiSelect',
        inheritAttrs: false,
        props: {
            value: {
                type: [Number, String],
                default: '',
            },
            label: {
                type: String,
                default: null,
            },
            labelInside: {
                type: Boolean,
                default: false,
            },
            options: {
                required: true,
                type: Array,
            },
            parentClass: {
                type: String,
                default: '',
            },
            sort: {
                type: Boolean,
                default: false,
            },
            sortType: {
                type: String,
                default: 'ASC',
                validate: value => ['ASC', 'DESC'].includes(value),
            },
            sortKey: {
                type: String,
                default: 'label',
            },
        },
        data() {
            return {
                focus: false,
                inputValue: this.value,
            };
        },
        computed: {
            uniqueId() {
                return this._uid;
            },

            inputOptions() {
                if (this.sort) return this.sortedOptions;

                return this.options;
            },

            sortedOptions() {
                let sorted = this.options
                    .filter(({ value }) => value !== '')
                    .sort((a, b) => a[this.sortKey].localeCompare(b[this.sortKey]));

                if (this.sortType === 'DESC') {
                    sorted = sorted.reverse();
                }

                return [
                    this.options.find(({ value }) => value === ''),
                    ...sorted,
                ];
            },
        },
        methods: {
            handleInput() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value(newVal) {
                this.inputValue = newVal;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .custom-select {
        padding-right: 32px;
        box-shadow: 0 0 5px rgba(#000, 0.05);
    }

    .label-inside {
        .form-group-label {
            position: absolute;
            left: 0.75rem;
            padding: 5px;
            font-size: 9px;
            pointer-events: none;
        }

        select {
            padding-top: 18px;
        }
    }
</style>
